import { AnalyticsSource, FeatureFlagKeys, ICCUser, IEnvironment, UniqueId } from '@communication-center/data-objects';
import { commonActions } from '../actionTypes';
import { FEATURE_FLAGS_KEY, getItem } from '../../components/Dialogs/FeatureFlagDialog/FeatureFlagDialog';
import { AuthorizationData, SystemBase } from '../../infrastructure/WalkmeSdkProvider/types';

const supportedSystemTypes = ['Workstation', 'DesktopElectron', 'DesktopWindows', 'DesktopMac', 'DesktopTrackedApp'];

export interface IWalkmeImage {
    name: string;
    url: string;
    lastModified: string;
    isOriginalSrc?: boolean | null;
}

export interface ICommonState {
    authorized?: boolean;
    supportedSystemType?: boolean;
    user?: ICCUser;
    environments?: IEnvironment[];
    systems?: { [guid: string]: SystemBase };
    currentEnvironment?: IEnvironment;
    currentSystem?: UniqueId;
    currentNumericSystemId?: number;
    currentSystemTypeKey?: string;
    overrideFeatureFlags: Partial<{ [key in FeatureFlagKeys]: boolean }>;
    forcedAnalyticsSource?: AnalyticsSource;
    walkmeFeatureFlags?: string[];
}

export type ICommonStateAuthorized = ICommonState & Required<Pick<ICommonState, keyof AuthorizationData>>;

export const commonInitialState: ICommonState = {
    overrideFeatureFlags: getItem('localStorage', FEATURE_FLAGS_KEY)
};

export default function commonReducer(state: ICommonState = commonInitialState, action: $TSFixMe): Partial<ICommonState> {
    switch (action.type) {
        case commonActions.AUTHORIZE: {
            const supportedSystemType = supportedSystemTypes.includes(action.payload.currentSystemTypeKey);
            return {
                ...state,
                ...(action.payload as AuthorizationData),
                supportedSystemType,
                authorized: true
            };
        }

        case commonActions.ENVIRONMENT_CHANGED: {
            const { environments } = state;
            const { payload: currentEnvironment } = action;

            return {
                ...state,
                environments: environments
                    ? environments.some(({ id }) => id === currentEnvironment.id)
                        ? environments
                        : [...environments, currentEnvironment]
                    : [currentEnvironment],
                currentEnvironment
            };
        }
        case commonActions.SYSTEM_CHANGED: {
            const supportedSystemType = supportedSystemTypes.includes(action.payload.currentSystemTypeKey);

            return {
                ...state,
                ...action.payload,
                supportedSystemType,
                featureFlags: commonInitialState.overrideFeatureFlags
            };
        }

        case commonActions.SET_LOCAL_FEATURE_FLAGS: {
            return { ...state, overrideFeatureFlags: action.payload };
        }

        case commonActions.SET_FORCE_ANALYTICS_SOURCE: {
            return { ...state, forcedAnalyticsSource: action.payload };
        }

        default:
            return state;
    }
}
